var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "caches" } },
    [
      _c(
        "Row",
        [
          _c(
            "Col",
            { attrs: { span: "12" } },
            [
              _c(
                "Row",
                {
                  staticClass: "tableCell",
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { gutter: 8 },
                },
                [
                  _c(
                    "Col",
                    {
                      staticStyle: {
                        height: "35px",
                        "line-height": "35px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "margin-right": "5px",
                          },
                        },
                        [_vm._v(" 设置缓存 ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "Form",
                {
                  staticStyle: { width: "50%", margin: "0 auto" },
                  attrs: {
                    "label-position": "left",
                    model: _vm.formSet,
                    "label-width": 70,
                  },
                },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "缓存KEY", "label-width": 70 } },
                    [
                      _c("Input", {
                        staticStyle: { width: "250px" },
                        attrs: { type: "text" },
                        model: {
                          value: _vm.formSet.key,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSet, "key", $$v)
                          },
                          expression: "formSet.key",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    { attrs: { label: "哈希KEY", "label-width": 70 } },
                    [
                      _c("Input", {
                        staticStyle: { width: "250px" },
                        attrs: { type: "text" },
                        model: {
                          value: _vm.formSet.hashkey,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSet, "hashkey", $$v)
                          },
                          expression: "formSet.hashkey",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    { attrs: { label: "缓存值", "label-width": 70 } },
                    [
                      _c("Input", {
                        staticStyle: { width: "250px" },
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.formSet.values,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSet, "values", $$v)
                          },
                          expression: "formSet.values",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("FormItem", [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.set },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Col",
            { attrs: { span: "12" } },
            [
              _c(
                "Row",
                {
                  staticClass: "tableCell",
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { gutter: 8 },
                },
                [
                  _c(
                    "Col",
                    {
                      staticStyle: {
                        height: "35px",
                        "line-height": "35px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "margin-right": "5px",
                          },
                        },
                        [_vm._v(" 删除缓存 ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "Form",
                {
                  staticStyle: { width: "50%", margin: "0 auto" },
                  attrs: { "label-position": "left", model: _vm.formDel },
                },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "缓存KEY", "label-width": 70 } },
                    [
                      _c("Input", {
                        staticStyle: { width: "250px" },
                        attrs: { type: "text" },
                        model: {
                          value: _vm.formDel.key,
                          callback: function ($$v) {
                            _vm.$set(_vm.formDel, "key", $$v)
                          },
                          expression: "formDel.key",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    { attrs: { label: "哈希KEY", "label-width": 70 } },
                    [
                      _c("Input", {
                        staticStyle: { width: "250px" },
                        attrs: { type: "text" },
                        model: {
                          value: _vm.formDel.hashkey,
                          callback: function ($$v) {
                            _vm.$set(_vm.formDel, "hashkey", $$v)
                          },
                          expression: "formDel.hashkey",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("FormItem", [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.submit },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }